import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../Loader";
import ViewInfo from "../Announcements/Announcement.module.css";
import { AxiosInstance } from "../../../../axios";
import ConfirmationPopup from "../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";
import toast from "react-hot-toast";

const ViewCouierCharges = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { STATUS, DATE } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [isActive, setIsActive] = useState(0);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot be available in session storage");
  }
  const [formFields, setFormFields] = useState({
    Weight_range: "",
    Amount: "",
    Status: "",
  });

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/book/courier/view", {
      id: parseInt(id),
    })
      .then((res) => {
        if (res.data.status === true && res.data.data?.length > 0) {
          const courseData = res.data.data[0];
          // console.log(courseData, "data");

          setFormFields({
            Weight_range: `${courseData.start_gram_range} - ${courseData.end_gram_range}`,
            Amount: courseData.amount,
            Status: courseData.isActive,
          });
          setIsActive(courseData.isActive);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [id]);

  const navigateToPreviousScreen = () => {
    navigate(`/CourierCharges`, {
      state: {
        filter_status: STATUS,
        filter_date: DATE,
      },
    });
  };

  const handleNavigate = (id) => {
    navigate(`/EditCourierCharges/${id}`);
  };
  const handleDelete = () => {
    if (!id) {
      console.error("ID is missing");
      return;
    }

    AxiosInstance.post("/api/book/courier/delete", {
      id: id,
      updated_by: userid,
    })
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          handleClose();
          navigate(-1);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error("Delete failed:", error);
        toast.error("Failed to delete courier charge.");
      });
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      {showModal && (
        <ConfirmationPopup
          open={showModal}
          title="Remove Courier Charges"
          message="Are you sure you want to remove this courier charges?"
          onConfirm={handleDelete}
          onCancel={handleClose}
        />
      )}
      <div className={`${ViewInfo.CourseInfoSec} BathHeader global_container`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">View Courier Charge</h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  // onClick={handleBackFilter}
                  onClick={navigateToPreviousScreen}
                  to="javascript:void(0)"
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back to Courier Charges
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  onClick={() => handleShow()}
                  className="primaryButton"
                  variant="primary"
                >
                  Remove Courier Charge
                </Link>
              </li>
              {isActive === 1 && (
                <li className="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    onClick={() => handleNavigate(id)}
                    className="primaryButton"
                    variant="primary"
                  >
                    <span className="material-icons me-1 fs-5 align-middle text-white">
                      border_color
                    </span>
                    Edit Courier Charge
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Courier Charge Details</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    Weight Range (in grams)
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.Weight_range || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Amount</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.Amount || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Status</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {formFields.Status === 1 ? "Active" : "InActive" || "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </>
  );
};
export default ViewCouierCharges;
